// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "ai_turn_input".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { aiTurnAgentValues } from '@borradh-workspace/labels';
/** Response atom for the "ai_turn_input" table (1:1 with a DB row, on the wire). */
export const aiTurnInputAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    agent: z.enum(aiTurnAgentValues),
    turnKind: z.string(),
    conversationId: z.string().nullable(),
    assistantConversationId: z.string().nullable(),
    triggerMessageId: z.string().nullable(),
    replyMessageIds: z.array(z.string()),
    outcome: z.string(),
    failure: z.string().nullable(),
    startedAt: z.string().datetime(),
    finishedAt: z.string().datetime(),
    appRelease: z.string(),
    traceId: z.string().nullable(),
    models: z.array(z.string()),
    promptVariant: z.string().nullable(),
    settings: z.unknown(),
    externalCalls: z.unknown(),
    source: z.string(),
    schemaVersion: z.number(),
    flaggedAt: z.string().datetime().nullable(),
    flagReason: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=aiTurnInput.js.map